import { render, staticRenderFns } from "./simulate.voyage.mobile.vue?vue&type=template&id=9706f952&scoped=true"
import script from "./simulate.voyage.mobile.vue?vue&type=script&lang=js"
export * from "./simulate.voyage.mobile.vue?vue&type=script&lang=js"
import style0 from "./simulate.voyage.mobile.vue?vue&type=style&index=0&id=9706f952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706f952",
  null
  
)

export default component.exports